"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }
function _construct(t, e, r) { if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _setPrototypeOf(p, r.prototype), p; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _isNativeFunction(fn) { try { return Function.toString.call(fn).indexOf("[native code]") !== -1; } catch (e) { return typeof fn === "function"; } }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
var CustomProductVariantsPicker = /*#__PURE__*/function (_HTMLElement) {
  _inherits(CustomProductVariantsPicker, _HTMLElement);
  function CustomProductVariantsPicker() {
    _classCallCheck(this, CustomProductVariantsPicker);
    return _callSuper(this, CustomProductVariantsPicker);
  }
  _createClass(CustomProductVariantsPicker, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      this.getCurrentVariant();
      this.bindChange();
    }
  }, {
    key: "bindChange",
    value: function bindChange() {
      var _this = this;
      this.variants = this.querySelectorAll(".variant-input");
      this.variants.forEach(function (element) {
        element.addEventListener("change", _this.variantsChanged.bind(_this));
      });
    }
  }, {
    key: "getVariantData",
    value: function getVariantData() {
      this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
      return this.variantData;
    }
  }, {
    key: "variantsChanged",
    value: function variantsChanged() {
      this.originVariant = this.currentVariant;
      this.getCurrentVariant();
      if (!this.currentVariant) {
        this.updateVariantInput();
        this.toggleAddButton(true, window.variantStrings.unavailable);
        return;
      }
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
    }
  }, {
    key: "getCurrentSize",
    value: function getCurrentSize() {
      var size = this.querySelector(".size-variant-input:checked");
      return size === null || size === void 0 ? void 0 : size.value;
    }
  }, {
    key: "getCurrentColor",
    value: function getCurrentColor() {
      var color = this.querySelector(".color-variant-input:checked");
      return color === null || color === void 0 ? void 0 : color.value;
    }
  }, {
    key: "getCurrentVariant",
    value: function getCurrentVariant() {
      var variants = this.getVariantData();
      var color = this.getCurrentColor();
      var size = this.getCurrentSize();
      var variant = variants.find(function (d) {
        var options = d.options || [];
        if (color != null && size != null) {
          return options[0] === color && options[1] === size;
        }
        if (color != null) {
          return options[0] === color;
        }
        if (size != null) {
          return options[1] === size;
        }
        return false;
      });
      this.currentVariant = variant || null;
    }
  }, {
    key: "updateURL",
    value: function updateURL() {
      if (!this.currentVariant || this.dataset.updateUrl === "false") return;
      window.history.replaceState({}, "", "".concat(this.dataset.url, "?variant=").concat(this.currentVariant.id));
    }
  }, {
    key: "updateVariantInput",
    value: function updateVariantInput() {
      var _this2 = this;
      var productForms = document.querySelectorAll("#product-form-".concat(this.dataset.section, ", #product-form-installment-").concat(this.dataset.section));
      productForms.forEach(function (productForm) {
        var input = productForm.querySelector('input[name="id"]');
        if (!input) return;
        if (!_this2.currentVariant) {
          input.value = "";
          input.disabled = true;
          return;
        }
        input.disabled = false;
        input.value = _this2.currentVariant.id;
        input.dispatchEvent(new Event("change", {
          bubbles: true
        }));
      });
    }
  }, {
    key: "toggleAddButton",
    value: function toggleAddButton() {
      var disable = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      var text = arguments.length > 1 ? arguments[1] : undefined;
      var modifyClass = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
      var productForm = document.getElementById("product-form-".concat(this.dataset.section));
      if (!productForm) return;
      var addButton = productForm.querySelector('[name="add"]');
      var addButtonText = productForm.querySelector('[name="add"] > span');
      if (!addButton) return;
      if (disable) {
        addButton.setAttribute("disabled", "disabled");
        if (text) addButtonText.textContent = text;
      } else {
        addButton.removeAttribute("disabled");
        addButtonText.textContent = window.variantStrings.addToCart;
      }
      if (!modifyClass) return;
    }
  }, {
    key: "renderProductInfo",
    value: function renderProductInfo() {
      var _this3 = this;
      if (!this.currentVariant) return;
      var requestedVariantId = this.currentVariant.id;
      var sectionId = this.dataset.section;
      var originVariant = this.originVariant;
      var currentVariant = this.currentVariant;
      fetch("".concat(this.dataset.url, "?variant=").concat(requestedVariantId, "&section_id=").concat(this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section)).then(function (response) {
        return response.text();
      }).then(function (responseText) {
        if (_this3.currentVariant.id !== requestedVariantId) return;
        var html = new DOMParser().parseFromString(responseText, "text/html");
        var addButtonUpdated = html.getElementById("ProductSubmitButton-".concat(sectionId));
        _this3.toggleAddButton(addButtonUpdated ? addButtonUpdated.hasAttribute("disabled") : true, window.variantStrings.soldOut);
        document.getElementById("custom-product-price").textContent = html.getElementById("custom-product-price").textContent;
        if (originVariant && originVariant.options[0] !== currentVariant.options[0]) {
          document.querySelector("#custom-color-variants").innerHTML = html.querySelector("#custom-color-variants").innerHTML;
          document.getElementById("custom-size-variants").querySelector(".size-list").innerHTML = html.querySelector("#custom-size-variants .size-list").innerHTML;
          _this3.bindChange();
          var slides = html.querySelector("#main-product-slider");
          var originSlides = document.querySelector("#main-product-slider");
          originSlides.replaceWith(slides);
        }
      });
    }
  }, {
    key: "disconnectedCallback",
    value: function disconnectedCallback() {}
  }]);
  return CustomProductVariantsPicker;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));
if (!customElements.get("custom-product-variants-picker")) {
  customElements.define("custom-product-variants-picker", CustomProductVariantsPicker);
}
